import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import {
  NAV_LINKS,
  RESPONSIBLE_MESSAGE,
  TACOVERSE_MENU_URL,
  TACOVERSE_ORDER_URL,
  TACOVERSE_URL,
} from "../data/brand";

export default function Footer() {
  return (
    <footer className="bg-[#1E1E1E]" data-testid="footer">
      <div className="container-x py-16 md:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo size="lg" />
            <p className="mt-6 flex flex-wrap items-center gap-3 font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-white/75">
              <img src="/images/tacosun.png" alt="" className="h-5 w-auto" aria-hidden="true" />
              <span>Food by</span>
              <a
                href={TACOVERSE_URL}
                className="text-tcv-yellow transition-colors hover:text-white"
                data-testid="footer-tacoverse"
              >
                Tacoverse™
              </a>
            </p>
            <p className="mt-2 font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-bv-gold">
              Tex Mex Auténtico
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/75">{RESPONSIBLE_MESSAGE}</p>
          </div>

          <nav className="lg:col-span-3" aria-label="Footer — experience">
            <h2 className="field-label !text-white/60">Experience</h2>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-white/75 transition-colors hover:text-white"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-2" aria-label="Footer — Tacoverse">
            <h2 className="field-label !text-white/60">Tacoverse™</h2>
            <ul className="space-y-3">
              <li>
                <a
                  href={TACOVERSE_URL}
                  className="inline-flex items-center gap-1.5 text-sm text-white/75 transition-colors hover:text-white"
                  data-testid="footer-visit-tacoverse"
                >
                  Visit tacoverse.com
                  <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
                </a>
              </li>
              <li>
                <a
                  href={TACOVERSE_MENU_URL}
                  className="inline-flex items-center gap-1.5 text-sm text-white/75 transition-colors hover:text-white"
                  data-testid="footer-tacoverse-menu"
                >
                  Full food menu
                  <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
                </a>
              </li>
              <li>
                <a
                  href={TACOVERSE_ORDER_URL}
                  className="inline-flex items-center gap-1.5 text-sm text-white/75 transition-colors hover:text-white"
                  data-testid="footer-order-online"
                >
                  Order online
                  <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </nav>

          <nav className="lg:col-span-2" aria-label="Footer — company">
            <h2 className="field-label !text-white/60">Company</h2>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-sm text-white/75 transition-colors hover:text-white" data-testid="footer-link-contact">Contact</Link></li>
              <li><Link to="/privacy" className="text-sm text-white/75 transition-colors hover:text-white" data-testid="footer-link-privacy">Privacy</Link></li>
              <li><Link to="/terms" className="text-sm text-white/75 transition-colors hover:text-white" data-testid="footer-link-terms">Terms</Link></li>
              <li><Link to="/accessibility" className="text-sm text-white/75 transition-colors hover:text-white" data-testid="footer-link-accessibility">Accessibility</Link></li>
            </ul>
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/15 pt-6 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
            © Barverse™ · barverse.com
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
            21+ · Please drink responsibly
          </p>
        </div>
      </div>
    </footer>
  );
}
